import React from 'react'
import {
    Link,
  } from "react-router-dom";

export const Security = (props) => {
    return (
        <div>
            <div className="container">

                <h3 className="mt-4 mb-3" style={{fontFamily: 'effraReg'}}>BronzeTag Security
            
                </h3>

                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" style={{fontFamily: 'effraReg'}}>Security</li>
                </ol>

                <div className="row">
                <div class="col-lg-12">
                    <p style={{fontFamily: 'effraReg'}}> At BronzeTag, security of your data and software is our #1 concern. When it comes to your data in the cloud, rest assured that its only visible to you and to your employees. BronzeTag POS also gives you full control of your users and what they can and connot do.</p>
                </div>
                
                </div>
            
            
            
            

    
    

    

            </div>
        </div>
    )
}